import axios from './axiosInstance';
import { APIRoleDefinition, APIRoleAssignmentsResponse, APIRoleAssignment } from '../../types';

interface GetRoleDefinitionsParams {
  sport: string;
  parkId: string;
  scope?: string;
  resourceType?: string;
  resourceId?: string;
}

interface GetRoleAssignmentsParams {
  sport: string;
  parkId: string;
  principalType?: string;
  principalId?: string;
  resourceType?: string;
  resourceId?: string;
  expand?: string;
  limit?: number;
  pageCursor?: string;
}

interface AssignRoleParams {
  sport: string;
  parkId: string;
  assigneeType: string;
  assigneeId: string;
  role: string;
  scope: string;
  resourceType?: string;
  resourceId?: string;
}

interface RevokeRoleParams {
  sport: string;
  parkId: string;
  roleId: string;
}

const getRoleDefinitions = ({ sport, parkId, scope, resourceType, resourceId }: GetRoleDefinitionsParams): Promise<APIRoleDefinition[]> => {
  const url = `/${sport}/areas/${parkId}/roles/definitions`;
  const params: Record<string, string> = {};

  if (scope) params.scope = scope;
  if (resourceType) params.resourceType = resourceType;
  if (resourceId) params.resourceId = resourceId;

  return axios.get(url, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getRoleAssignments = ({ sport, parkId, principalType, principalId, resourceType, resourceId, expand, limit, pageCursor }: GetRoleAssignmentsParams): Promise<APIRoleAssignmentsResponse> => {
  const url = `/${sport}/areas/${parkId}/roles/assignments`;
  const params: Record<string, string | number> = {};

  if (principalType) params.principalType = principalType;
  if (principalId) params.principalId = principalId;
  if (resourceType) params.resourceType = resourceType;
  if (resourceId) params.resourceId = resourceId;
  if (expand) params.expand = expand;
  if (limit) params.limit = limit;
  if (pageCursor) params.pageCursor = pageCursor;

  return axios.get(url, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const assignRole = ({ sport, parkId, assigneeType, assigneeId, role, scope, resourceType, resourceId }: AssignRoleParams): Promise<APIRoleAssignment> => {
  const url = `/${sport}/areas/${parkId}/roles/assign`;
  const body: Record<string, string> = {
    assigneeType,
    assigneeId,
    role,
    scope,
  };

  if (resourceType) body.resourceType = resourceType;
  if (resourceId) body.resourceId = resourceId;

  return axios.post(url, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const revokeRole = ({ sport, parkId, roleId }: RevokeRoleParams): Promise<any> => {
  const url = `/${sport}/areas/${parkId}/roles/${roleId}/revoke`;

  return axios.post(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const rolesFunctions = {
  getRoleDefinitions,
  getRoleAssignments,
  assignRole,
  revokeRole,
};

export default rolesFunctions;
